module.exports = __webpack_public_path__ + "static/media/p3.edd9e8ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/p3.jpg
// module id = 137
// module chunks = 0